import { Input, Table, Tag } from "antd";
import DownloadCsv from "./DownloadCsv";
import React, { useState } from "react";
import { SearchOutlined } from '@ant-design/icons';

const ViewReport = ({ reportData, startDate, endDate }) => {

    const [searchText, setSearchText] = useState('');

    const safeReportData = Array.isArray(reportData) ? reportData : reportData ? [reportData] : [];

    const filteredData = Array.isArray(safeReportData)
    ? safeReportData.filter((item) =>
        (item?.bin_id?.toString().toLowerCase().includes(searchText.toLowerCase()) || 
         item?.kanban_no?.toString().toLowerCase().includes(searchText.toLowerCase()))
    )
    : [];

    const generateFilters = (data, key) => {
        if (!data.length) return []; // Return an empty array if no data
        const uniqueValues = [...new Set(data.map(item => item[key]))];
        return uniqueValues.map(value => ({ text: value, value }));
    };

    const columns = [
        {
            title: 'SI.No',
            dataIndex: 'SNo',
            sorter: (a, b) => a.SNo - b.SNo,
        },
        {
            title: 'Item No',
            dataIndex: 'item_no',
            sorter: (a, b) => a.item_no.localeCompare(b.item_no),
        },
        {
            title: 'Kanban No',
            dataIndex: 'kanban_no',
            sorter: (a, b) => a.kanban_no.localeCompare(b.kanban_no),
        },
        {
            title: 'Po No',
            dataIndex: 'po_no',
            filters: generateFilters(safeReportData, 'po_no'),
            filterSearch: true,
            onFilter: (value, record) => record.po_no === value,
        },
        {
            title: 'Line No',
            dataIndex: 'line_no',
            filters: generateFilters(safeReportData, 'line_no'),
            filterSearch: true,
            onFilter: (value, record) => record.line_no === value,
        },
        {
            title: 'Dispatch Area',
            dataIndex: 'dispatch_area',
            filters: generateFilters(safeReportData, 'dispatch_area'),
            filterSearch: true,
            onFilter: (value, record) => record.dispatch_area === value,
        },
        {
            title: 'Bin Id',
            dataIndex: 'bin_id',
            sorter: (a, b) => a.bin_id - b.bin_id,
        },
        {
            title: "Size & Qty",
            dataIndex: "size_name",
            render: (sizeName) => {
              if (typeof sizeName === "string") {
                try {
                  sizeName = JSON.parse(sizeName);
                } catch (error) {
                  return <Tag color="red">Invalid Data</Tag>;
                }
              }
              return Object.entries(sizeName).map(([size, qty]) => (
                <Tag key={size} color="blue">
                  {size}: {qty}
                </Tag>
              ));
            },
        },
        {
            title: 'Total Qty',
            dataIndex: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
        },
        {
            title: 'Color',
            dataIndex: 'color',
        },
        {
            title: 'Added By',
            dataIndex: 'added_by',
        },
        {
            title: 'Added On',
            dataIndex: 'added_on',
            sorter: (a, b) => new Date(a.added_on) - new Date(b.added_on),
        },
    ];

    const getSizeData = (size_name) => {
        try {
            const sizeObj = JSON.parse(size_name);
            return Object.entries(sizeObj)
                .filter(([key, value]) => value)
                .map(([size, quantity]) => ({ size, quantity }));
        } catch (error) {
            return [];
        }
    };

    // Expanded Row Renderer for size subtables
    const expandedRowRender = (record) => {
        const sizeData = getSizeData(record.size_name);
        if (!sizeData.length) return null;

        return (
            <Table
                columns={[
                    { title: 'Size', dataIndex: 'size', key: 'size' },
                    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
                ]}
                dataSource={sizeData}
                pagination={false}
                rowKey="size"
                size="small"
            />
        );
    };

    const onChange = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
    };

    return (
        <Table
            size="small"
            title={() => (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Input
                    placeholder="Search Bin, Kanban ID"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    allowClear
                    prefix={<SearchOutlined style={{ color: '#1890ff' }} />}
                    style={{ width: 300 }}
                />
                <DownloadCsv
                    flag={false}
                    reportData={reportData}
                    startDate={startDate}
                    endDate={endDate}
                />
                </div>
            )}
            columns={columns}
            dataSource={filteredData}
            onChange={onChange}
            rowKey="eol_id"
        />
    );
};

export default ViewReport;
